type EventWithOrganization = {
	logo?: string | null
	organization?: {
		logo?: string | null
		default_image?: string | null
	} | null
}

export function resolveEventDisplayImage(event: EventWithOrganization | null | undefined): string | null {
	if (!event) return null
	return event.logo || event.organization?.logo || event.organization?.default_image || null
}
